import React from "react";
import cn from "classnames";
import styles from "./Overview.module.sass";
import Card from "../../../components/Card";
import Icon from "../../../components/Icon";
import { useAuth } from "../../../contexts/AuthContext";

const staticItemsData = [
  {
    key: "totalStudents",
    title: "Apprenants",
    icon: "profile-circle",
    background: "#edf8f2",
  },
  {
    key: "totalGroups",
    title: "Groupes",
    icon: "store",
    background: "#ecf9fe",
  },
  {
    key: "totalTeachers",
    title: "Intervenants",
    icon: "shopping-bag",
    background: "#e8f1fd",
  },
  {
    key: "totalSessions",
    title: "Sessions",
    icon: "calendar",
    background: "#fef3e8",
  },
];

const Overview = ({ className, overviewData }) => {
  const { currentUser } = useAuth();

  const itemsToDisplay = staticItemsData.map(item => ({
    ...item,
    counter: overviewData ? overviewData[item.key] : item.counter,
  }));

  return (
    <>
      <Card
        className={cn(styles.card, className)}
        title={`Votre tableau de bord, ${currentUser?.first_name || 'Utilisateur'}`}
        classTitle="title-blue"
      >
        <div className={styles.overview}>
          <div className={styles.list}>
            {itemsToDisplay.map((x, index) => (
              <div
                className={styles.item}
                key={index}
                style={{ backgroundColor: x.background }}
              >
                <div className={styles.icon}>
                  <Icon name={x.icon} size="24" />{" "}
                </div>
                <div className={styles.line}>
                  <div className={styles.details}>
                    <div className={styles.category}>{x.title}</div>
                    <div className={styles.counter}>{x.counter}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </Card>
    </>
  );
};

export default Overview;
